import * as types from "../../actions/types";

// One sidebar indicator: status is "idle" | "ok" | "error".
const indicator = { status: "idle", count: 0 };

const INITIAL_STATE = {
  myDay: { loading: false, loaded: false, data: null, error: null },
  indicators: {
    drafts: indicator, // DRAFT emails visible to the user (matches the Emails page)
    inbox: indicator, // unmatched info@ mail (matches the Inbox page)
    gaps: indicator, // open leads with no next action, team-wide (should be 0)
  },
};

const crmFlowReducers = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.CRM_FLOW_MY_DAY_LOADING:
      return { ...state, myDay: { ...state.myDay, loading: true } };
    case types.CRM_FLOW_MY_DAY_SUCCESS:
      return { ...state, myDay: { loading: false, loaded: true, data: action.payload, error: null } };
    case types.CRM_FLOW_MY_DAY_FAILURE:
      return { ...state, myDay: { ...state.myDay, loading: false, loaded: true, error: action.payload } };
    case types.CRM_FLOW_INDICATOR:
      return {
        ...state,
        indicators: {
          ...state.indicators,
          [action.payload.key]:
            action.payload.count === null
              ? { status: "error", count: state.indicators[action.payload.key]?.count || 0 }
              : { status: "ok", count: action.payload.count },
        },
      };
    default:
      return state;
  }
};

export default crmFlowReducers;
